import { DataComponentBaseModel } from "../../models/data-mesh/data-component.model";

export class DataProductCreateRequest {
    public name: string;
    public idPrimaryDataSet: number;
    public datetimeColumn: string = "datetime_inclusion";
    public isDeleted: boolean = false;
    public profiles: number[] = [];
    public dataComponents: DataComponentBaseModel[] = [];
}